import type { ReactNode } from 'react';

import { Button } from '#/components/Button/Button';
import { useI18n } from '#/i18n/hooks/useI18n';
import { trackClicked } from '#/utils/analytics/track/trackClicked';
import { highlightElement } from '#/utils/highlightElement';

type Props = {
  tabIndex?: number;
  applied: boolean;
  eventName: string;
  children?: ReactNode;
  qaId?: string;
};

export function ScrollToApplyButton({
  tabIndex,
  applied,
  eventName,
  children,
  qaId,
}: Props) {
  const { i18n } = useI18n();

  if (applied) {
    return (
      <Button
        type="button"
        qaId="easy-apply-button"
        disabled
        variant="primary"
        tabIndex={tabIndex}
        icon={{ name: 'simple-check', color: 'brandGreen' }}
      >
        {children ?? i18n('Applied')}
      </Button>
    );
  }

  return (
    <Button
      type="link"
      href="#apply"
      variant="primary"
      anchorType="native"
      qaId={qaId ?? 'easy-apply-button'}
      tabIndex={tabIndex}
      onClick={(event) => {
        event.preventDefault();

        trackClicked(eventName);

        const applyButton = document.getElementById('apply');
        if (applyButton) {
          applyButton.scrollIntoView();
          highlightElement(applyButton);
        }
      }}
    >
      {children ?? i18n('Apply')}
    </Button>
  );
}
